<vc-dialog
    [(visible)]="visible"
    [title]="dialogTitle"
    width="430px"
    [primaryLabel]="'COMMON_UI.DELETE' | transloco"
    [secondaryLabel]="'COMMON_UI.CANCEL' | transloco"
    [closeOnSecondary]="true"
    [showCloseIcon]="true"
    [actionsOnLeft]="false"
    (primaryTrigger)="clickYes()">
    @if (dialogDescription) {
        <p>{{ dialogDescription }}</p>
    }
</vc-dialog>
